import {Section} from 'components/forms';
import {useFormPersistence} from 'components/forms/hooks';
import React, {useContext} from 'react';
import {LoopContext} from 'components/forms/context';
import get from 'lodash.get';
import {P} from 'components/TypographyShortcuts';
import {PositionCardForm} from 'components/forms';
import {Button, Grid} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {PBold} from 'components/TypographyShortcuts';

const useStyles = makeStyles(theme => ({
    addButton: {
        backgroundColor: theme.palette.primary.light2,
    },
}));

const VesselPositionSummmary = props => {
    const {state} = useFormPersistence();
    const classes = useStyles();

    const looper = useContext(LoopContext);
    const loopNode = looper
        ? looper.parent
            ? `${looper.parent.node}[${looper.parent.index}].${looper.node}`
            : `${looper.node}`
        : '';
    const data = get(state, loopNode, []);
    const vesselName = get(state, `${looper.parentNodePath}.vessel_name`);

    const handleAddMoreService = () => {
        looper.addNew();
        looper.goTo(0, window.location.pathname);
    };

    return (
        <Section {...props}>
            {looper ? (
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <P>
                            Great! If you served more than one time period,
                            position, or route on this vessel, click the button
                            below to add more sea service on {state.vessel_name}
                            .
                        </P>
                    </Grid>
                    <Grid item xs={12}>
                        <PBold>{vesselName} Sea Service</PBold>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        container
                        spacing={2}
                        justifyContent='center'
                    >
                        {data?.map((position, index) => (
                            <Grid item xs={12} key={`position-${index}`}>
                                <PositionCardForm
                                    position={position}
                                    index={index}
                                    shaded
                                    sslType={state.ssl_type}
                                />
                            </Grid>
                        ))}
                        <Grid item xs={12}>
                            <Button
                                variant='contained'
                                className={classes.addButton}
                                onClick={handleAddMoreService}
                                data-cy='add-more-sea-service'
                            >
                                + Add More Sea Service on This Vessel
                            </Button>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <PBold>
                            If you're done entering info for this vessel, click
                            'Next.'
                        </PBold>
                    </Grid>
                </Grid>
            ) : (
                <P>This section requires a loop parent.</P>
            )}
        </Section>
    );
};

export default VesselPositionSummmary;
